<template>
  <page layout="tabbed">
    <page-header-new :title="$t('Campaign_TemplatesPage_Title')">
      <template slot="actions">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="createTemplateCampaign"
          v-if="$can('createProjectItem')"
        >
          {{ $t('Template_CampaignsPage_CreateTemplate_Btn') }}
        </el-button>
      </template>
    </page-header-new>
    <page-tabs :tabs="tabs"></page-tabs>
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import PageTabs from '@/common/components/page/PageTabs'
import { projectRoute } from '@/core/helpers'
export default {
  name: 'TemplateCampaignsPage',
  components: { PageTabs, PageHeaderNew, Page },
  methods: {
    createTemplateCampaign() {
      this.$router.push(projectRoute({ name: 'CreateTemplateCampaign' }))
    }
  },
  computed: {
    tabs() {
      return [
        {
          title: this.$t('Template_CampaignsPage_Tab_Custom'),
          route: projectRoute({ name: 'TemplateCampaignsTab' })
        },
        {
          title: this.$t('Template_CampaignsPage_Tab_PreMade'),
          route: projectRoute({ name: 'PreMadeTemplatesTab' })
        }
      ]
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaigns/pages/TemplateCampaignsPage.vue